export default __webpack_public_path__ + "static/media/full2.9a2add35.jpg";